import { Component } from "react";
import React from "react";
import "./hector.css";
import { Box, Typography } from "@mui/material";
import Navbar from "../../../../Home/Components/Nav";
import Footer from "../../../../Home/Components/Footer";
import Hectorcarrousel from "./Hectorcaraosole";
import Features from "./Features/Features";
import Accessories from "./Accessories/Accessories";
import Carrosuel from "./cardcarousel";
import "bootstrap/dist/css/bootstrap.min.css";
import Contactus from "../../../../contact/Container/Contactformcon";
import Deets from "../../../../MgHector/Components/Hector/Component/deetssection";
import Faq from "../../../../MgHector/Components/Hector/Component/faqs";
import WhatsNew from "./WhatsNew";

const ismart =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Hector%2Fbannericon%2Fi-smart.1iconhector.svg?alt=media&token=2631ae02-dc7d-4beb-8fcc-e8380f85f5ab";
const sunroof =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Hector%2Fbannericon%2Fsunrooficonhector.svg?alt=media&token=ee3e45b0-7769-4f2b-a3a9-60842a33e8ec";
const hd =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Hector%2Fbannericon%2Fhdscreeniconhector.svg?alt=media&token=a49b2e7c-22bd-4921-b482-292040604c6a";
const system =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Hector%2Fbannericon%2Flasticonhector.png?alt=media&token=7bfe7715-ca24-4413-a084-f3ed5aecad13";
class Hector extends Component {
  constructor(props) {
    super(props);

    // ✅ STATE PROPERLY INITIALIZED
    this.state = {
      bannerColor: "#F64752", // default navy
    };
  }

  handleColorChange = (color) => {
    this.setState({ bannerColor: color });
  };

  render() {
    return (
      <div id="container">
        <Navbar />
        <style>{`
        body {
    margin: 0;
    padding: 0;
  }
          .video-hect {
    width: 100%;
    height: 120vh;
    background: #000;
    overflow: hidden;
    display: block;
  }

  .wrapper-hect {
    width: 100%;
    height: 100%;
  }

  .wrapper-hect video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  #banner-image-hector {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
        `}</style>
        <div className="video-hect">
          <div className="video-hect">
            <div className="wrapper-hect">
              <video
                autoPlay
                muted
                loop
                playsInline
                poster="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-vd-dsc-005.mp4?alt=media&token=119a6c7c-22be-4479-b7a2-6f07f869ca19"
              >
                <source
                  src="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-vd-dsc-005.mp4?alt=media&token=119a6c7c-22be-4479-b7a2-6f07f869ca19"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>

        </div>


        <WhatsNew/>
        {/* Banner */}
        <div
          id="banner-image-hector"
          style={{
            backgroundColor: this.state.bannerColor,
            transition: "background-color 0.4s ease",
          }}
        >
          <div id="hect-left">
            <div id="hl1">
              {/* <img src={ismart} alt="logo1"  />
              <p>i-Smart<br/>
             70+ Connected Car Features</p> */}
            </div>
            <div id="hl2">
              {/* <img src={sunroof} alt="logo2"  />
              <p>PANORAMIC SUNROOF</p> */}
            </div>
          </div>
          <div id="hect-center">
            <div id="hc1">
              {/* <img src={mglogo} alt="logo-content" height="180px" width="400px" /> */}
            </div>
            <div id="hectc2" style={{}}>
              <Hectorcarrousel onColorChange={this.handleColorChange} />
            </div>
          </div>
          <div id="hect-right">
            <div id="hr1">
              {/* <img src={hd} alt="logo3"  /> */}
              {/* <p>INFOTAINMENT SYSTEM<br/>
               India’s Largest Portrait HD screen</p> */}
            </div>
            <div id="hr2">
              {/* <img src={system} alt="logo4"  /> */}
              {/* <p>AUTONOMOUS LEVEL 2</p> */}
            </div>
          </div>
        </div>
    
        {/* Features Section */}
        <Features />

        {/* All that Deets */}
        <Box
          id="features"
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: { md: "0", xs: "0" },
            marginTop: { md: "20px", xs: "0" },
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { md: "2.08333vw", xs: "6vw" },
              color: "#cf2230",
              fontFamily: "GillSansSemiBold, Arial, sans-serif",
              paddingBottom: { md: "3.125vw", xs: "20px" },
              fontWeight: "400",
              textAlign: "center",
              marginTop: "10px",
            }}
          >
            All The Deets
          </Typography>
          <Deets />
        </Box>

        {/* Accessories */}
        {/* <Accessories/> */}

        {/* Cards Carousel Section */}
        <Carrosuel />

        {/* contact us */}
        {/* <Contactus/> */}
        <Contactus someValue="Hector" />

        {/* calculator */}
        {/* <Box
              sx={{
                height: { md: '66vh', xs: 'auto' }, // Set auto height for small screens
                width: '100%',
                display: 'flex',
                flexDirection: 'column', 
                justifyContent: 'center',
                alignItems: 'center',
                '@media (min-width: 1024px) and (max-width: 1139px)': {
                    height:'84vh'
                  },
                  '@media (min-width: 1440px) and (max-width: 1439px)': {
                    height:'74vh'
                  },
              }}
            >
              <Typography
                sx={{
                  fontSize: { md: '2.08333vw', xs: '4.4vw' },
                  color: '#cf2230',
                  fontFamily: 'GillSansSemiBold, Arial, sans-serif',
                  paddingBottom: { xs: '5vw', md: '3.125vw' },
                  fontWeight: '400',
                }}
              >
                EMI CALCULATOR
              </Typography>

              <Box
                sx={{
                  height: { md: '58vh', xs: 'auto' },
                  width: { xs: '95%', md: '87%' },
                  boxShadow: '0px 0px 20px grey',
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' }, 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  '@media (min-width: 1024px) and (max-width: 1139px)': {
                    flexDirection:'column',
                    height:'75vh'
                  },
                }}
                
              >
                <Box
                  sx={{
                    height: { md: '58vh', xs: 'auto' },
                    width: { xs: '100%', md: '100px' },
                    backgroundColor: '#E32735',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: { xs: '10px', md: 0 },
                    '@media (min-width: 1024px) and (max-width: 1139px)': {
                    width:'100%',
                    height:'130px'
                  },
                  }}
                >
                  <img src={calculator} height='90px' width='80px' alt='calculator' />
                </Box>

                <Box
                  sx={{
                    height: { md: '58vh', xs: 'auto' },
                    width: { xs: '100%', md: '880px' },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: { xs: '20px 0', md: '0' }, 
                  }}
                >
                  <Box
                    sx={{
                      height: 'auto', 
                      width: { xs: '100%', md: '850px' },
                      display: 'flex',
                      flexDirection: { xs: 'column', md: 'row' },
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: { xs: '20px', md: '30px' },
                      '@media (min-width: 1024px) and (max-width: 1139px)': {
                    marginTop:'-60px',
                  },
                    }}
                  >
                    <Box
                      sx={{
                        height: { md: '35vh', xs: 'auto' }, // Let content size naturally on small screens
                        width: '200px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                    >
                      <Typography sx={{ fontFamily: 'Gill Sans', marginTop: { xs: '20px', md: 0 } }}>
                        LOAN AMOUNT(₹)
                      </Typography>
                      <Slider defaultValue={10} aria-label="Default" valueLabelDisplay="auto" />
                      <Box sx={{ height: '20px', width: '200px', display: 'flex', color: 'grey', gap: '53px' }}>
                        <Typography sx={{ fontFamily: 'Gill Sans' }}>from ₹10K</Typography>
                        <Typography sx={{ fontFamily: 'Gill Sans' }}>to ₹13.99L</Typography>
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        height: { md: '35vh', xs: 'auto' },
                        width: '200px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                    >
                      <Typography sx={{ fontFamily: 'Gill Sans' }}>INTEREST RATE (%) P.A</Typography>
                      <Slider defaultValue={10} aria-label="Default" valueLabelDisplay="auto" />
                      <Box sx={{ height: '20px', width: '200px', display: 'flex', color: 'grey', gap: '90px' }}>
                        <Typography sx={{ fontFamily: 'Gill Sans' }}>from 7%</Typography>
                        <Typography sx={{ fontFamily: 'Gill Sans' }}>to 15%</Typography>
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        height: { md: '35vh', xs: 'auto' },
                        width: '200px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                    >
                      <Typography sx={{ fontFamily: 'Gill Sans' }}>TENURE (YEARS)</Typography>
                      <Slider defaultValue={10} aria-label="Default" valueLabelDisplay="auto" />
                      <Box sx={{ height: '20px', width: '200px', display: 'flex', color: 'grey', gap: '60px' }}>
                        <Typography sx={{ fontFamily: 'Gill Sans' }}>from 1 year</Typography>
                        <Typography sx={{ fontFamily: 'Gill Sans' }}>to 8 years</Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      height: '22vh', 
                      width: { xs: '100%', md: '850px' },
                      backgroundColor: '#FAFAFA',
                      display: 'flex',
                      flexDirection: { xs: 'row', md: 'row' }, 
                      justifyContent: 'space-evenly', 
                      alignItems: 'center',
                      padding: { xs: '20px', md: '10px' }, 
                    }}
                  >
                    <Box
                      sx={{
                        height: 'auto',
                        width: '100%', // Full width on small screens
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                    >
                      <Typography sx={{ fontFamily: 'Gill Sans', fontSize: { xs: '10px' } }}>LOAN AMOUNT</Typography>
                      <Typography sx={{ fontFamily: 'Roboto-Medium', fontWeight: '700', fontSize: { md: '25px', xs: '15px' } }}>
                        ₹10,000
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        height: 'auto',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                    >
                      <Typography sx={{ fontFamily: 'Gill Sans', fontSize: { xs: '10px' } }}>DOWN PAYMENT</Typography>
                      <Typography sx={{ fontFamily: 'Roboto-Medium', fontWeight: '700', fontSize: { md: '25px', xs: '15px' } }}>
                        ₹50,000
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        height: 'auto',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                    >
                      <Typography sx={{ fontFamily: 'Gill Sans', fontSize: { xs: '10px' } }}>EMI AMOUNT</Typography>
                      <Typography sx={{ fontFamily: 'Roboto-Medium', fontWeight: '700', fontSize: { md: '25px', xs: '15px' } }}>
                        ₹1,000
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    height: 'auto',
                    width: { xs: '100%', md: '230px' },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '20px',
                    marginTop: { xs: '20px', md: 0 }, // Add margin on smaller screens to separate sections
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'GillSansSemiBold',
                      fontSize: { xs: '4vw', md: '20px' },
                      fontWeight: 'bold',
                    }}
                  >
                    CAR PRICE
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Roboto-Bold',
                      fontSize: { xs: '5vw', md: '24px' },
                      fontWeight: 'bold',
                      marginBottom:{md:'30px',xs:'20px'}
                    }}
                  >
                    ₹13,99,000*
                  </Typography>
                </Box>
              </Box>
            </Box> */}

        {/* faqs */}
        <Faq />
        {/* Image*/}

        {/* <div id="hectorimg"></div> */}

        {/* Pricing Section */}
        {/* <Pricing/> */}

        <Footer />
      </div>
    );
  }
}

export default Hector;
